import { hasBase } from '@aytm/app/stats/page/question-views/answer-variants/components/chart/lib/chartModes'

export const getChartModeTypes = ({ answer, percentsOnly = false }) => {
  if (hasBase(answer) || percentsOnly) return ['percents', 'bpercents']

  return ['pie', 'respondents', 'percents', 'brespondents', 'bpercents']
}

export const getDefaultChartMode = ({ chartMode, globalChartMode, answer, percentsOnly = false }) => {
  let mode = chartMode === 'off' ? globalChartMode : chartMode
  mode = mode || globalChartMode

  if ((hasBase(answer) || percentsOnly) && !['percents', 'bpercents'].includes(mode)) {
    return 'percents'
  }

  return mode
}
